module.exports = __webpack_public_path__ + "static/img/5.b46a335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/5.png
// module id = TsRu
// module chunks = 1